// extracted by mini-css-extract-plugin
export default {"sliders":"DefinePrioritiesModal_sliders__vn7-G","hint":"DefinePrioritiesModal_hint__iBvuL"};